export { default as VictoryPie } from "./victory-pie";
export { default as Slice } from "./slice";